// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Y3-z","colorTextValue":"Z3-z","swatches":"_3-z","collapseLink":"a4-z","isCollapsed":"b4-z","dropdown":"c4-z","disabled":"d4-z"};